// Models
import { AuthUser } from '../AuthUser/AuthUser';
import { FeatureFlag } from '../feature-flag/feature-flag';

export class UserSessionData {
  applicationId = '91056BD7-0375-49F7-8E47-103E21442590';
  user: AuthUser;
  isTpaAdmin: boolean;
  featureFlags: FeatureFlag[] = new Array<FeatureFlag>();

  constructor() {
    this.user = new AuthUser();
  }
}
